export default __webpack_public_path__ + "static/BUS_5-47aa3c2986e2ef6ed3043b7376e0d0f9.jpg";